module.exports = {
      id: "british-flag-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#british-flag",
      toString: function () {
        return this.url;
      }
    }